import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
import { Metrics } from "@newrelic/browser-agent/features/metrics";
import { getEnvironment } from "./urlHelpers";
import { Envs } from "../@types";
import { config } from "../config";
import { devDebug } from "./loggingHelpers";

const newRelicAppIds = {
  [Envs.local]: "1126981212",
  [Envs.test]: "1108843833",
  [Envs.dev]: "1115837220",
  [Envs.imp]: "1127015170",
  [Envs.prod]: "1127000604",
};

export const initializeNewRelic = () => {
  const env = getEnvironment();
  const config = getNewRelicConfiguration(env);

  if (!config) {
    devDebug(
      "New Relic browser agent not initialized, due to missing license key"
    );
    return;
  }

  new BrowserAgent(config);

  const releaseVersion = import.meta.env.VITE_RELEASE_VERSION;

  if (releaseVersion) {
    newrelic.addRelease("mct", releaseVersion);
  }
  newrelic.setCustomAttribute("Environment", env);
  newrelic.setCustomAttribute("team_name", "mct");
  newrelic.setCustomAttribute("Application", "mct");
  newrelic.setCustomAttribute("FISMA", "moss");
};

const getNewRelicConfiguration = (env: Envs) => {
  const { NEW_RELIC_BROWSER_API_KEY } = config;

  const applicationID = newRelicAppIds[env];
  const agentID = applicationID;
  const licenseKey = NEW_RELIC_BROWSER_API_KEY;
  const accountID = "2036148";
  const beacon = "gov-bam.nr-data.net";
  const errorBeacon = beacon;
  const trustKey = "39033";

  if (!licenseKey) {
    return;
  }

  return {
    init: {
      distributed_tracing: { enabled: true },
      privacy: { cookies_enabled: true },
    },
    info: {
      beacon,
      errorBeacon,
      licenseKey,
      applicationID,
      sa: 1,
    },
    loader_config: {
      accountID,
      trustKey,
      agentID,
      licenseKey,
      applicationID,
    },
    features: [Metrics],
  };
};
